




































// Composition
import { defineComponent, computed } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'

// Store
import { useCompareProductsStore } from '@/store/compare-products'

// Components
import IconFa6SolidXmark from '~icons/fa6-solid/xmark'

// Composables
import useSearchUrl from '@/composables/search/useSearchUrl'
import useSearchAnalytics from '@/composables/analytics/useSearchAnalytics'
import { useI18n } from '~/composables/i18n'

export default defineComponent({
  components: {
    IconFa6SolidXmark,
  },
  setup() {
    const { trackSearchCompare } = useSearchAnalytics()
    const { getSearchUrl } = useSearchUrl()
    const compareStore = useCompareProductsStore()
    const { comparedProducts, getCompareProductsUrl } = storeToRefs(compareStore)
    const showCompareButtons = computed(() => {
      return comparedProducts.value.filter((el) => el.error === undefined).length > 1
    })

    const { t } = useI18n()
    const onCompareClick = () => {
      // Send analytics
      trackSearchCompare()

      // store URL in sessionStorage

      // This is needed for ATG compare page
      // TODO - delete after sunset ATG
      sessionStorage.setItem('redirectBackUrl', getSearchUrl())
    }

    return {
      comparedProducts,
      getCompareProductsUrl,
      compareStore,
      onCompareClick,
      showCompareButtons,
      t,
    }
  },
})
